module.exports = __webpack_public_path__ + "img/2.84864ab9.jpg";